var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261154251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.1244 14.4381C2.4164 13.7301 2.88598 12.2437 2.52562 11.3727C2.15205 10.4698 0.78125 9.74317 0.78125 8.78122C0.78125 7.81929 2.15206 7.09264 2.52562 6.18977C2.88599 5.31881 2.4164 3.8324 3.1244 3.1244C3.83239 2.4164 5.31882 2.88598 6.18978 2.52562C7.09266 2.15205 7.81933 0.78125 8.78128 0.78125C9.74321 0.78125 10.4699 2.15206 11.3727 2.52562C12.2437 2.88599 13.7301 2.4164 14.4381 3.1244C15.1461 3.83239 14.6765 5.31882 15.0369 6.18978C15.4105 7.09266 16.7812 7.81933 16.7812 8.78128C16.7812 9.74321 15.4104 10.4699 15.0369 11.3727C14.6765 12.2437 15.1461 13.7301 14.4381 14.4381C13.7301 15.1461 12.2437 14.6765 11.3727 15.0369C10.4698 15.4105 9.74317 16.7812 8.78122 16.7812C7.81929 16.7812 7.09264 15.4104 6.18977 15.0369C5.31881 14.6765 3.8324 15.1461 3.1244 14.4381Z",
    fill: "url(#paint0_linear_72_3626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1677 6.93506L7.65482 11.2428L5.39844 9.0889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_3626",
    x1: -3.81875,
    y1: -6.21875,
    x2: 27.4551,
    y2: -0.248289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989439,
    stopColor: "#3DBDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829491,
    stopColor: "#067D71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.1f00b78470cdd95ea95f5e7f3924a03e.svg";
export { ForwardRef as ReactComponent };